import { coprincipalAccountIndexerFromSourceId } from './coprincipalAccountIndexerFromSourceId';
import type AccountKey from './AccountKey';
import { defaultAccountKey } from './AccountKey';

/**
 * Returns the account key based on the sourceId
 * @param sourceId SourceId of a coprincipal account or a resource account
 * @returns String representing the account key or undefined if no key was found
 */
export default function getAccountKeyForSourceId(sourceId: string): AccountKey {
    return (coprincipalAccountIndexerFromSourceId(sourceId) as AccountKey) ?? defaultAccountKey;
}
